import { chipsToBb } from "../engine/selectors.js";

interface BetAmountInputProps {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
}

/**
 * Plain numeric bet-amount input, no +/- stepper (2026-07-17 フィードバック
 * #3 -- the stepper buttons were removed; typing, and the preset/action
 * button sync, are unaffected). Lives in the hero's `PlayerPanel` center
 * column now, not the action bar, so it's rendered by `PlayScreen` directly
 * rather than by `BetControls`/`ActionBar`.
 */
export function BetAmountInput({ min, max, value, onChange }: BetAmountInputProps) {
  return (
    <div className="hero-bet-input-wrap">
      <input
        className="hero-bet-input"
        type="number"
        inputMode="decimal"
        min={min}
        max={max}
        value={chipsToBb(value)}
        step={0.5}
        onFocus={(e) => e.target.select()}
        onChange={(e) => {
          const bb = Number(e.target.value);
          if (Number.isFinite(bb)) onChange(Math.max(min, Math.min(max, Math.round(bb * 2))));
        }}
      />
      <span className="hero-bet-unit">bb</span>
    </div>
  );
}
